// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"2ac4f74a","55":"76a03d1c","114":"bb2eac9b","191":"0d6a5509","213":"aa16cdb3","311":"d024e004","436":"2323ebc9","473":"e4632a24","506":"9e91e5b2","530":"3e72bcc0","545":"b56d33ca","612":"4cf2a131","797":"775f6cfd","896":"2d0ace92"}[chunkId] + ".chunk.js";
};